import { FilterKey } from '../types';

export interface FilterConfig {
  placeholder: string;
}

export const filterConfigs: Record<FilterKey, FilterConfig> = {
  locations: {
    placeholder: 'e.g. Brisbane'
  },
  years_of_experience: {
    placeholder: 'Enter years of experience'
  },
  job_titles: {
    placeholder: 'e.g. Talent acquisition specialist'
  },
  industries: {
    placeholder: 'e.g. Technology'
  },
  skills: {
    placeholder: 'e.g. Good communication'
  }
};
